import { gql } from 'apollo-angular'

export default gql`
  query downloadImgaes($phantomTestId: Int!, $userId: Int!) {
    downloadPhantomTestImages(
      data: { phantomTestId: $phantomTestId, userId: $userId }
    )
  }
`
